import React, { useEffect } from 'react';
import LoadingSpinner from './LoadingSpinner';
import visionXLogo from 'src/resources/images/vision-x-white.png';

/**
 * Full-screen centred loading state.
 * Used in three places so the position is always identical:
 *   1. App.tsx isLoading — session/system initialisation
 *   2. React.Suspense fallback — lazy chunk loading
 *   3. index.html inline HTML — pre-React boot (matches this layout exactly)
 *
 * On first mount, removes the pre-React boot overlay (#pre-react-loader)
 * so the transition is seamless — the overlay stays visible until this
 * component is actually painted by React.
 */
const FullScreenLoader = (): React.ReactElement => {
  useEffect(() => {
    const loader = document.getElementById('pre-react-loader');
    if (loader) {
      loader.classList.add('fade-out');
      loader.addEventListener('transitionend', () => loader.remove(), { once: true });
    }
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1.5rem',
        backgroundColor: 'var(--L0-BG, #0a0a0b)',
        zIndex: 9999,
      }}
    >
      <img
        className="img-fluid"
        src={visionXLogo}
        alt="VisionX"
        style={{ maxWidth: '160px' }}
      />
      <LoadingSpinner />
    </div>
  );
};

export default FullScreenLoader;
